import { render, staticRenderFns } from "./purchase-show-print.vue?vue&type=template&id=fa94ea74&scoped=true&"
import script from "./purchase-show-print.vue?vue&type=script&lang=js&"
export * from "./purchase-show-print.vue?vue&type=script&lang=js&"
import style0 from "./purchase-show-print.vue?vue&type=style&index=0&id=fa94ea74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94ea74",
  null
  
)

export default component.exports